//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ApartmentCard',
  props: ['apartment', 'hideDetails', 'investmentId'],
  data: function() {
    console.log(this.apartment);
    return {
      url: window.location.origin,
      status: this.apartment.status.toLowerCase(),
      isSold: this.apartment.status.toLowerCase() == 'sprzedane',
      isReserved: this.status == 'rezerwacja',
      isAvailable: this.status == 'wolne',
    };
  },
  methods: {
    handleApartmentClick() {
      if (!this.isSold) {
        // console.log("Apartment Clicked");
        // this.$emit("apartmentSelected", this.apartment.id);
      }
    },
    handlePriceHistoryClick(event) {
      event.stopPropagation();
      this.$emit('showPriceHistory', {
        apartmentId: this.apartment.id,
        investmentId: this.investmentId,
      });
    },
  },
  computed: {
    pricePerSqm() {
      // Remove 'zł' or 'PLN' from price string and parse as float
      const price = parseFloat(
        String(this.apartment.price)
          .replace(/[\s,]*(zł|PLN)/gi, '')
          .replace(/\s/g, '')
          .replace(',', '.')
      );

      const area = parseFloat(this.apartment.area.replace(',', '.'));
      return (price / area).toFixed(2);
    },
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/partials/ApartmentCard.vue